<template>
  <div class="setting">
    <v-container>
      <h2 class="mb-2">Settings</h2>
      <div class="test">
        <p>調査分析ページ</p>
      </div>
      <v-form ref="form" v-model="valid">
        <v-row>
          <v-col align="right"><v-btn @click.once="back">戻る</v-btn></v-col>
        </v-row>
        <v-divider class="ma-3"></v-divider>
        <v-row>
          <v-col>PageIDから検索</v-col>
          <v-col cols="6">
            <v-text-field
              v-model="pageID"
              :rules="[]"
              label="ページID"
              style="color: red"
              type="text"
              outlined
              background-color="white"
              hint="フォームIDから、顧客名,ページタイトル,フォームラベルを取得"
              persistent-hint
              hide-details="auto"
            >
            </v-text-field
          ></v-col>
          <v-col align="right"><v-btn @click="pageSearch">検索</v-btn></v-col>
        </v-row>
        <v-row>
          <v-col>顧客[{{ res2[1] }}]</v-col>
          <v-col>ページタイトル[{{ res2[0] }}]</v-col>
        </v-row>
        <v-divider class="ma-3"></v-divider>
        <v-row>
          <v-col>FormIDから検索</v-col>
          <v-col cols="6">
            <v-text-field
              v-model="formID"
              :rules="[]"
              label="フォームID"
              style="color: red"
              type="text"
              outlined
              background-color="white"
              hint="フォームIDから、顧客名,ページタイトル,フォームラベルを取得"
              persistent-hint
              hide-details="auto"
            >
            </v-text-field
          ></v-col>
          <v-col align="right"><v-btn @click="formSearch">検索</v-btn></v-col>
        </v-row>
        <v-row>
          <v-col>顧客[{{ res1[2] }}]</v-col>
          <v-col>ページタイトル[{{ res1[1] }}]</v-col>
          <v-col>フォームラベル[{{ res1[0] }}]</v-col>
        </v-row>
        <v-divider class="ma-3"></v-divider>
      </v-form>
    </v-container>
  </div>
</template>
<script>
import { RepositoryFactory } from "../../api/RepositoryFactory";
const api = RepositoryFactory.get("api2");

export default {
  name: "analysis",
  components: {},
  data: () => ({
    valid: true,
    //
    formID: null,
    pageID: null,
    //
    res1: ["顧客名", "ページ名", "フォーム名"],
    res2: ["顧客名", "ページ名"],
  }),
  async mounted() {
    //初期処理
    await this.getInit();
  },
  methods: {
    async getInit() {},
    back() {
      history.back();
    },
    //
    async formSearch() {
      const res = await api.AnalysisFormID(this.formID);
      this.res1 = res;
    },
    async pageSearch() {
      const res = await api.AnalysisPageID(this.pageID);
      this.res2 = res;
    },
  },
};
</script>
